import { FC } from 'react';
import isPrerender from '../../../../../utils/is-prerender';
import { SCHOOL_TYPES } from '../../../../../constants/school-types';
import SchoolMenu from '../school-menu/school-menu';

const PrerenderMegaMenuLinks: FC = () => {
    if (!isPrerender()) {
        return null;
    }

    return (
        <div className='d-none'>
            <SchoolMenu type={SCHOOL_TYPES.SECONDARY_SCHOOL} />
            <SchoolMenu type={SCHOOL_TYPES.PRIMARY_SCHOOL} />
        </div>
    );
};

export default PrerenderMegaMenuLinks;
